'use client'

import { MapPinnedIcon } from 'lucide-react'

import { NativeSelect, NativeSelectOption } from '@/components/ui/native-select'
import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { usStates } from '@/utilities/states'
import { cn } from '@/utilities/ui'

export const StateSelect = ({
  stateSelectMobileRef,
  stateSelectDesktopRef,
  selectedState,
  handleStateChange,
}: {
  stateSelectMobileRef?: React.RefObject<HTMLSelectElement>
  stateSelectDesktopRef?: React.RefObject<HTMLButtonElement>
  selectedState: string | undefined
  handleStateChange: (state: string) => void
}) => {
  return (
    <>
      {/* Mobile native select */}
      <NativeSelect
        ref={stateSelectMobileRef ?? undefined}
        onChange={(e) => handleStateChange(e.target.value)}
        value={selectedState || ''}
        className={cn('w-full lg:hidden', selectedState && 'font-semibold text-primary')}
      >
        <NativeSelectOption value="" disabled>
          Select a state
        </NativeSelectOption>
        {usStates.map((state) => (
          <NativeSelectOption key={state.value.toLowerCase()} value={state.value.toLowerCase()}>
            {state.label}
          </NativeSelectOption>
        ))}
      </NativeSelect>

      {/* Desktop select */}
      <div className="hidden w-full lg:block">
        <Select onValueChange={handleStateChange} value={selectedState}>
          <SelectTrigger
            ref={stateSelectDesktopRef ?? undefined}
            aria-label="Select a state"
            className={cn(
              'text-muted-foreground focus:ring-2 focus:ring-evergreen-500 focus:ring-offset-transparent focus:outline-none',
              selectedState && 'border-evergreen-200 bg-evergreen-50 text-accent',
            )}
          >
            <div
              className={cn(
                'flex items-center gap-2 font-body [&>span]:text-reg [&>span]:font-normal',
                selectedState && '[&>span]:text-reg [&>span]:font-semibold',
              )}
            >
              <MapPinnedIcon className="size-4.5 text-muted-foreground" />
              <SelectValue placeholder="Select a state" />
            </div>
          </SelectTrigger>
          <SelectContent>
            <SelectGroup>
              <SelectLabel>States</SelectLabel>
              {usStates.map((state) => (
                <SelectItem key={state.value.toLowerCase()} value={state.value.toLowerCase()}>
                  {state.label}
                </SelectItem>
              ))}
            </SelectGroup>
          </SelectContent>
        </Select>
      </div>
    </>
  )
}
